import { Outlet } from 'react-router-dom'
import { InterventionNav } from '@/pages/interventions/components/InterventionNav'
import useAuthStore from '@/stores/useAuthStore'
import useNavStore from '@/stores/useNavStore'

/**
 * Shared shell for all Interventiedesk pages. Renders the wireframe
 * sub-navigation (Dashboard · Aanvragen · Medewerkers · Facturatie) so those
 * sections are reachable. HR managers in "Beheer" already get these items from
 * the main navbar, so the in-page nav is skipped there to avoid duplication.
 */
const InterventionLayout = () => {
  const { user } = useAuthStore()
  const { showManagement } = useNavStore()
  const isHrManager = !!user?.companyMember?.isHrManager
  const showSubNav = !(isHrManager && showManagement)

  return (
    <div>
      {showSubNav && (
        <div className="mx-auto max-w-7xl px-4 pt-6 sm:px-6 lg:px-8">
          <InterventionNav />
        </div>
      )}
      <Outlet />
    </div>
  )
}

export default InterventionLayout
